<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Email Newsletter', route: '/backoffice/newsletter/' }, { label: 'Aggiungi Email Newsletter', route: '/backoffice/newsletter/add' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">AGGIUNGI EMAIL NEWSLETTER</h1>
</section>


<section class="pb-16 mb-8 px-container"> 
    <form [formGroup]="formNewsletter" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-8">                                                                
            <div class="w-full">
                <label>* Email</label>
                <input type="email" pInputText placeholder="Email" formControlName="email" name="email" id="email" required />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formNewsletter.get('email')?.hasError('required') && (formNewsletter.get('email')?.dirty || formNewsletter.get('email')?.touched)">L'email è obbligatoria!.</small>
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formNewsletter.get('email')?.hasError('email') && (formNewsletter.get('email')?.dirty || formNewsletter.get('email')?.touched)">L'email deve essere valida!.</small>
            </div>                                                                                    
            <button class="btn-outln-backoffice p-3 w-full font-medium" type="submit" [disabled]="!formNewsletter.valid">Aggiungi</button>
        </div>
    </form>
</section>